module.exports = __webpack_public_path__ + "img/logo_.aab063d5.png";